import { Complaint } from '../Complaint'
import { formSchema } from './schema'
import { ihsChildAbuse } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'
import {
  normalizeIHSVictimData,
  normalizeParentGuardianData
} from '../../utilities'

export class IHSChildAbuseComplaint extends Complaint {
  constructor(props) {
    super(props)
    this.complaintType = 'ihs_child_abuse'
    this.schema = formSchema(this.saveFormData)
    this.successURL = routes.ihschildabuse.confirmation
    this.source = 'ihs'
  }

  /*
   * Combine the IHS unique data with the common complaint data.
   */
  formatComplaintForRequest(formData) {
    formData.hhs_program = 'IHS'

    // Process the data unique to this complaint.
    const business_unit = 'IHS_OTHER'
    const hhs_program_detail = 'Child Abuse Hotline'
    const parentguardians = normalizeParentGuardianData(formData, 9)
    const victims = normalizeIHSVictimData(formData, 9)

    const detail = {
      business_unit,
      hhs_program_detail,
      parentguardians,
      victims
    }

    // Return the combined unique data and common data.
    return this.formatCommonComplaintFormData(formData, detail)
  }
}

export default withRecaptcha(
  withBackButtonProtection(withDocTitle(IHSChildAbuseComplaint, ihsChildAbuse))
)
